import "./indexeddb-crypto-store-B5yWDofq.js";
import { i as MXClient, t as context } from "./utils-CblOo2BU.js";
import { useCallback, useEffect, useMemo, useReducer } from "react";
import { jsx } from "react/jsx-runtime";
const YapContext = ({ children: s }) => {
	let c = useMemo(() => MXClient.get(), []);
	useEffect(() => (c.on("me", (e) => {
		u(["user", e.userId]);
	}), () => c.destroy()), [c]);
	let [l, u] = useReducer((e, o) => {
		switch (o[0]) {
			case "ready": return e;
			case "user": return {
				...e,
				user: o[1]
			};
			case "openChat": return {
				...e,
				rooms: {
					...e.rooms,
					[o[1]]: {
						nag: !0,
						open: !0
					}
				}
			};
			case "closeChat": return {
				...e,
				rooms: {
					...e.rooms,
					[o[1]]: {
						...e.rooms[o[1]],
						open: !1
					}
				}
			};
			case "unnag": return {
				...e,
				rooms: {
					...e.rooms,
					[o[1]]: {
						...e.rooms[o[1]],
						nag: !1
					}
				}
			};
			case "open": return {
				...e,
				namedTabs: {
					...e.namedTabs,
					[o[1]]: !0
				}
			};
			case "close": return {
				...e,
				namedTabs: {
					...e.namedTabs,
					[o[1]]: !1
				}
			};
		}
		return e;
	}, {
		stage: "INIT",
		namedTabs: {},
		rooms: {}
	}), d = useCallback(() => {
		window.open(c.getLoginUrl(window.location.href), "_self");
	}, [c]), f = useCallback((e) => {}, []), p = useCallback((e) => {}, []), m = useCallback(() => {
		new URLSearchParams(window.location.search).has("loginToken") && (console.debug("YapContext: Attempting to login with loginToken query parameter..."), c.login().then((e) => {
			console.debug("YapContext: Finished processing loginToken", e ? "and logged in" : "");
		}).catch((e) => {
			console.error("YapContext: Failed to process loginToken", e);
		}));
	}, [c]), h = useCallback(async () => {
		await c.logout();
	}, [c]);
	return /* @__PURE__ */ jsx(context.Provider, {
		value: {
			state: l,
			client: c,
			dispatch: u,
			doLogin: d,
			doLogout: h,
			openChat: f,
			setSystem: p,
			ready: m
		},
		children: s
	});
};
export { YapContext };
